import Loader from 'components/UI/loader/loader';
import { ModalStyled } from 'components/UI/styled/modal-styled';
import React, { useState } from 'react';
import Container from 'react-bootstrap/Container';
import { cnpjMask } from 'utils';
import FinancialDataService from 'services/FinancialData/FinancialData';
import FinancialAccountForm from './FinancialAccountForm';
import { Cnpj, LoaderContainer, Title } from './style';

const FinancialAccountModal = ({ isOpen, onClose, data, onEditedAccount }) => {
  const [isLoading, setIsLoading] = useState(false);

  const onSubmit = (formData) => {
    setIsLoading(true);
    FinancialDataService.saveAccount(formData).then(
      (success) => {
        onClose();
        setIsLoading(false);
        onEditedAccount(success?.message, formData, data.index);
      },
      (error) => {
        onClose();
        setIsLoading(false);
        onEditedAccount(
          'Ocorreu um erro ao editar os dados financeiros. Tente novamente.', 
          null, 
          0
        );
      });
  };

  const onCancel = () => {
    onClose();
  };

  return (
    <ModalStyled
      backdrop="static"
      show={isOpen}
      onHide={onClose}
      className="modal-md"
    >
      {isLoading && (
        <LoaderContainer>
          <Loader show={isLoading} />
        </LoaderContainer>
      )}
      <ModalStyled.Header closeButton>
        <ModalStyled.Title>Editar dados financeiros</ModalStyled.Title>
      </ModalStyled.Header>

      <ModalStyled.Body>
        <Container fluid className="pl-0 pr-0">
          <Title>{data?.data?.nomeIe?.toLowerCase()}</Title>
          <Cnpj>{cnpjMask(data?.data?.cnpj)}</Cnpj>

          <FinancialAccountForm
            data={data.data}
            onSubmit={(formData) => onSubmit(formData)}
            onCancel={() => onCancel()}
          />
        </Container>
      </ModalStyled.Body>
    </ModalStyled>
  );
};

export default FinancialAccountModal;
